const initialState = {
  data: 0,
  loading: false
}

const unreadConversationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'UNREAD_CONVERSATIONS_COUNT_FETCH_REQUESTED':
      return { ...state, loading: true }

    case 'UNREAD_CONVERSATIONS_COUNT_FETCH_SUCCEEDED':
      return { ...state, loading: false, data: action.response.unread_count }

    case 'UNREAD_CONVERSATIONS_COUNT_FETCH_FAILED':
      return initialState

    default:
      return state
  }
}

export default unreadConversationsReducer
